
export interface BuildJobInfo {
    Id: number,
    Toc: string,
    JobNumber: string,
    Description: string,
    CreatedDate: string,
    CreatedUser: string,
    Progress: number,
    Status: string,
    TicketTypeId:number,
    TicketType: string,
    OutputFolderPath: string,
    TypeId:number,
    ReleaseName:string|null
}



export interface Log {
    Id:number,
    JobId: number,
    TocId: number,
    TaskId: number,
    TypeId: number,
    Type: LogType,
    Description: string,
    Remarks: string,
    TaskTableNo:string,
    Nlc?:number,
    DateCreated:string,
    Icon:string
}

export enum LogType{
    Error=1,
    Warning=2,
    Info=3,
    Verbose=4
}

export enum JobType{
    Build=1,
    Release=2
}

export enum FileSearchTypes
{
    TOC,
    Build,
    TicketType,
    Station,    
    Job,
    Task,
    Release,
    ReleaseFiles
}

export enum OutputFileTypes
{
    Folder=0,
    File=1
}

export interface SearchOutputFileInput
{        
     TocId? :number,
      ParentSearchType :FileSearchTypes,
   TypeId?:OutputFileTypes,
    UserId? :number,
    StartDate?:string ,
   EndDate?:string ,
   IncludeJobsWithoutFile:boolean,
   ParentTypeId?:number
}

export interface OutputBuildFiles{
    TypeId: number,
    SearchType: FileSearchTypes,
    Name: string,
    OutputFileType:OutputFileTypes,
    SizeInKB?: number,
    CreatedDate?: string,
    CreatedBy: string,
    ParentTypeId?: number,
     ParentSearchType :FileSearchTypes,
   LegacyTypeId?:number,
   LegacySearchType:FileSearchTypes,
   //LegacyItems:LegacyItem[]
}


export interface ReleaseTable{
    TableId:number,
    TaskId:number|null,
    StationName:string,
    TableName:string,
    LastBuiltDateString:string|null,
    Version:string|null,
    OriginalVersion:string
}
export interface ReleaseFolder{
    VersionNo:number,
    UtsDate:number,
    ReleaseName:string
}

